














































































































































































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {$, Helper, InputCheckbox} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {InputResponsavelSchema} from '@/schema/resource/Responsavel/InputResponsavelSchema'
import {InputResponsavelFlagsSchema} from '@/schema/resource/Responsavel/InputResponsavelFlagsSchema'
import {InputResponsavelFlagsWithOptions} from '@/schema/resource/Responsavel/InputResponsavelFlagsWithOptionsSchema'
import {InputEnderecoSchema} from '@/schema/resource/Endereco/InputEnderecoSchema'
import {Endereco} from '@/model/resource/Endereco'
import FormEndereco from '@/components/FormEndereco.vue'
import {InputResponsavelSenhaSchema} from '@/schema/resource/Responsavel/InputResponsavelSenhaSchema'
import {InputResponsavelLiberacaoAcessoSchema} from '@/schema/resource/Responsavel/InputResponsavelLiberacaoAcessoSchema'
import {TipoCliente} from '@/model/resource/TipoCliente'
import {ApiPermission} from '@/model/resource/ApiPermission'
import {TipoCliente as TipoClienteEnum} from '@/enums/TipoCliente'
import FileManager from '@/components/FileManager.vue'
import {InputResponsavelVisualizacaoPainelSchema} from '@/schema/resource/Responsavel/InputResponsavelVisualizacaoPainelSchema'
import {ResponsavelUsuario} from '@/model/resource/ResponsavelUsuario'
import {InputResponsavelUsuarioDefaultSchema} from '@/schema/resource/Responsavel/InputResponsavelUsuarioDefaultSchema'

@Component({
  components: {FileManager, FormEndereco, InputCheckbox},
})
export default class PersistResponsavelView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelSchema()
  responsavelFlagsSchema = new InputResponsavelFlagsSchema()
  enderecoSchema = new InputEnderecoSchema()
  responsavelFlagsWithOptionsSchema = new InputResponsavelFlagsWithOptions()
  responsavel = new Responsavel()
  responsavelUsuario = new ResponsavelUsuario()
  responsavelSenhaSchema = new InputResponsavelSenhaSchema(this.responsavel)
  responsavelLiberacaoAcessoSchema = new InputResponsavelLiberacaoAcessoSchema()
  responsavelVisualizacaoPainelSchema = new InputResponsavelVisualizacaoPainelSchema()
  responsavelUsuarioSchema = new InputResponsavelUsuarioDefaultSchema()
  Helper = Helper

  async created() {
    this.responsavel.endereco = new Endereco()
    this.responsavel.tipoCliente = new TipoCliente()
    this.responsavel.tipoCliente.idTipoClientePk = TipoClienteEnum.Cliente

    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responsavel.getResponsavel(id)
    } else {
      this.responsavel.apiPermission = await ApiPermission.listApiPermission()
    }

    $.await.done('getResponsavel')
  }

  async persist() {
    this.formatData()

    const {
      isSenhaResponsavelMatch,
      isSenhaVisualizadorMatch,
      isSenhaIntegracaoMatch,
    } = this.responsavelSenhaSchema

    const {
      isSenhaDevolverNotaMatch,
      isSenhaExcluirNotasFinalizadasMatch,
      isSenhaDevolverNotaFinalizadaParaNaoIniciadaMatch,
    } = this.responsavelFlagsWithOptionsSchema

    const isPasswordValid =
      (isSenhaVisualizadorMatch ?? true) &&
      (isSenhaIntegracaoMatch ?? true) &&
      (isSenhaResponsavelMatch ?? true) &&
      (isSenhaDevolverNotaMatch ?? true) &&
      (isSenhaExcluirNotasFinalizadasMatch ?? true) &&
      (isSenhaDevolverNotaFinalizadaParaNaoIniciadaMatch ?? true)

    const isValid = await this.validator.validateAll()

    if (!isValid || !isPasswordValid) {
      Helper.abort('system.error.validation')
    }

    if (this.id != null && Number(this.id) > 0) {
      await this.responsavel.persistResponsavel()
    } else {
      await this.responsavel.persistResponsavelComUsuario(
        this.responsavelUsuario
      )
    }
    await Helper.successAndPush('system.success.persist', '/responsavel/list')
  }

  formatData() {
    this.responsavel.nomeResponsavelCadastroUltimaModificacao = (this.$auth
      .administrador?.email as string).toUpperCase()

    this.responsavel.razaoSocial =
      this.responsavel.razaoSocial?.toUpperCase() ?? null
    this.responsavel.nomeFantasia =
      this.responsavel.nomeFantasia?.toUpperCase() ?? null
    this.responsavel.nomeContato =
      this.responsavel.nomeContato?.toUpperCase() ?? null
    this.responsavel.email = this.responsavel.email?.toUpperCase() ?? null
    this.responsavel.parceiroNome =
      this.responsavel.parceiroNome?.toUpperCase() ?? null
    this.responsavel.integracaoTMS =
      this.responsavel.integracaoTMS?.toUpperCase() ?? null
    this.responsavel.nomeResponsavelTorreDeControle =
      this.responsavel.nomeResponsavelTorreDeControle?.toUpperCase() ?? null
    this.responsavel.dominiosAutorizados =
      this.responsavel.dominiosAutorizados?.toLocaleLowerCase() ?? null

    if (this.responsavelUsuario) {
      this.responsavelUsuario.nome =
        this.responsavelUsuario.nome?.toLocaleLowerCase() ?? null
      this.responsavelUsuario.email =
        this.responsavelUsuario.email?.toLocaleLowerCase() ?? null
    }

    if (this.responsavel.endereco) {
      this.responsavel.endereco.cidade =
        this.responsavel.endereco.cidade?.toUpperCase() ?? null
      this.responsavel.endereco.logradouro =
        this.responsavel.endereco.logradouro?.toUpperCase() ?? null
      this.responsavel.endereco.bairro =
        this.responsavel.endereco.bairro?.toUpperCase() ?? null
    }
  }
}
